/**
 * Whether a text placement is switched on in the builder.
 *
 * A product can define several default placements for one text (a number on
 * the back AND on the front); the customer turns placements off in the
 * customizer, which the builder persists as `selected: false` on the item and
 * skips at render time (`src/lib/productTextRenderability.ts`,
 * `isTextItemVisible`). Same rule here, or the production file prints a number
 * the customer removed.
 */
export function isTextPlacementOn(item: { selected?: unknown } | null | undefined): boolean {
  const s = item?.selected;
  return !(s === false || s === 0 || s === '0');
}
